export default __webpack_public_path__ + "pin.e8ee8957e0779076ca078eb75a98657d.png";